export default {
  methods: {
    numberEnding(number, endings) {
      if (!endings) return '';
      let sEnding;
      if (window._SYSTEM_LANGUAGE === 'ru') {
        let i;
        number = number % 100;
        if (number >= 11 && number <= 19) {
          sEnding = endings[2];
        } else {
          i = number % 10;
          switch (i) {
            case (1):
              sEnding = endings[0];
              break;
            case (2):
            case (3):
            case (4):
              sEnding = endings[1];
              break;
            default:
              sEnding = endings[2];
          }
        }
      } else {
        sEnding = endings[number === 1 ? 0 : 1];
      }

      return sEnding;
    },
    numberFormat( number, decimals = 0, dec_point = ',', thousands_sep = ' ' ) {  // Format a number with grouped thousands
      let i, j, kw, kd, km;

      if( isNaN(decimals = Math.abs(decimals)) ){
        decimals = 2;
      }

      i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

      if( (j = i.length) > 3 ){
        j = j % 3;
      } else{
        j = 0;
      }

      km = (j ? i.substr(0, j) + thousands_sep : "");
      kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
      kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

      return km + kw + kd;
    },
  }
};
